import Swiper from "https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.mjs";

class RteCarousel extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    this.startCarousel();
  }

  startCarousel() {
    const swiper = new Swiper(this, {
      slidesPerView: "auto",
      autoplay: {
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
        delay: 5000,
      },
      spaceBetween: 0,
      loop: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
  }
}

customElements.define("rte-carousel", RteCarousel);
